module.exports = __webpack_public_path__ + "static/media/DB-1538_58x58x58_GXX_3X.a183c4f7.tom";